<div class="header">
  <div class="count">
    이 그룹책에 총 <b>{{ _total }}</b
    >개의 댓글이 있습니다.
  </div>
  <select
    sui-select
    [(ngModel)]="_selectedSortType"
    (ngModelChange)="_onSortTypeChange()"
  >
    <option *ngFor="let sortType of _sortTypes" [value]="sortType">
      {{ sortType }}
    </option>
  </select>
</div>

<!-- 로딩 오버레이 -->
<div class="loading-overlay" *ngIf="_isLoadingComment">
  <div class="loading-content">
    <sui-loader></sui-loader>
  </div>
</div>

<div
  class="body"
  #scrollContainer
  suiListIntersectionObserver
  [observerOptions]="{ rootMargin: '0px 0px -160px 0px' }"
  [class.loading-disabled]="_isLoadingComment"
>
  <div
    class="comment-input-form"
    *ngIf="isOwnedByUser"
    [class.is-active]="isCommentInputValid"
  >
    <div class="input-area">
      <textarea
        rows="1"
        #commentInput
        [readonly]="!isCommentInputValid"
        [placeholder]="
          !isCommentInputValid
            ? '본문을 드래그하여 \'댓글\' 메뉴 선택 후 생각을 공유하세요'
            : ''
        "
        [(ngModel)]="commentInputValue"
        (scroll)="_onTextareaScroll($event)"
        (keydown.arrowup)="_onTextareaArrowKey($event)"
        (keydown.arrowdown)="_onTextareaArrowKey($event)"
        (keydown.arrowleft)="_onTextareaArrowKey($event)"
        (keydown.arrowright)="_onTextareaArrowKey($event)"
        (keydown)="_onTextareaKeyDown($event)"
        (input)="_onCommentInputChange()"
      ></textarea>
    </div>
  </div>
  <div
    class="comment-input-action-buttons"
    *ngIf="isCommentInputValid && isOwnedByUser"
  >
    <span class="is-active" (click)="_cancelCommentInput()">취소</span>
    <span
      [class.is-active]="commentInputValue.trim() !== ''"
      (click)="_onCommentInputKeyDown($event)"
      >저장</span
    >
  </div>

  <div class="divider"></div>

  <div class="no-comments" *ngIf="_memos?.length === 0">
    <div class="no-comments-text">
      <p class="no-comments-text-title">아직 댓글이 없습니다.</p>
    </div>
  </div>

  <div class="memo" *ngFor="let memo of _memos; trackBy: trackByMemoId">
    <viewer-reading-mode-memo
      class="memo-comp"
      [attr.data-memo-id]="memo.id"
      [class.is-active]="memo.id === _activeMemo?.id"
      [memo]="memo"
      [text]="memo.text"
      [currentPage]="_currentPage"
      [isOwnedByUser]="isOwnedByUser"
      (memoDeleted)="_refresh()"
      (memoBlinded)="_refresh()"
      (memoUserBlocked)="_refresh()"
      [isUnread]="!memo.is_read"
      [isAuthorOnline]="_onlineUserMap[memo.author.id]"
      suiListItemIntersectionObserver
      (intersected)="_onMemoRead(memo)"
      [stopAfterIntersection]="true"
      (memoUpdated)="_onMemoUpdated(memo, $event)"
      (replyCommentClick)="_onReplyCommentClick($event)"
      (subReplyCommentChanged)="_onSubReplyCommentChanged($event)"
      [limitHeight]="_shouldLimitHeight(memo)"
    ></viewer-reading-mode-memo>
  </div>
</div>

<!-- 댓글 입력창 -->
<div
  class="mobile-input-form"
  #mobileInputForm
  [class.is-active]="isCommentInputValid"
>
  <div
    class="comment-input-notification-popup"
    *ngIf="isCommentInputNotificationActive"
  >
    <ng-container *ngIf="isCommentInputNotificationType === 'comment'">
      <span>
        "
        <span class="viewer-text">
          {{ annotationText }}
        </span>
        " 본문에 댓글 다는 중
      </span>
      <sui-icon
        name="엑스"
        (click)="_onCloseCommentInputNotification($event)"
      ></sui-icon>
    </ng-container>

    <ng-container *ngIf="isCommentInputNotificationType === 'reply'">
      <span>
        <span class="viewer-text">
          {{ _selectedComment?.author.nickname }}
        </span>
        님에게 답글 다는 중
      </span>
      <sui-icon
        name="엑스"
        (click)="_onCloseCommentInputNotification($event)"
      ></sui-icon>
    </ng-container>
  </div>

  <div class="input-area">
    <div
      class="nickname-indent"
      #nicknameElement
      *ngIf="
        _isReplyCommentInputOpen && _getMentionTarget() && isCommentInputValid
      "
    >
      &commat;{{ _getMentionTarget()?.nickname }}
    </div>
    <textarea
      rows="1"
      #mobileCommentInput
      [readonly]="!isCommentInputValid"
      [placeholder]="
        !isCommentInputValid
          ? '본문을 드래그 후 \'댓글\' 메뉴를 선택하면 댓글을 입력할 수 있습니다'
          : ''
      "
      [(ngModel)]="commentInputValue"
      [style.text-indent]="isCommentInputValid ? _getNicknameIndent() : '0px'"
      (scroll)="_onTextareaScroll($event)"
      (keydown.arrowup)="_onTextareaArrowKey($event)"
      (keydown.arrowdown)="_onTextareaArrowKey($event)"
      (keydown.arrowleft)="_onTextareaArrowKey($event)"
      (keydown.arrowright)="_onTextareaArrowKey($event)"
      (keydown)="_onTextareaKeyDown($event)"
      (input)="_onCommentInputChange()"
    ></textarea>
  </div>

  <div
    class="input-submit-buttons"
    [class.is-active]="isCommentInputValid"
    (click)="_onMobileCommentInputSubmit()"
  >
    <sui-icon name="왼쪽 이동"></sui-icon>
  </div>
</div>
